<template>
    <div style="height: 100%;">
        <div style="margin-bottom: 10px; display: flex; justify-content: space-between; align-items: center;">
            <h3 style="margin-bottom: 0;">线路列表</h3>
        </div>
        <div style="margin-bottom: 10px; display: flex; gap: 10px;">
            <el-input v-model="searchKeyword" size="small" placeholder="请输入线路名称" clearable style="width: 100%;">
                <i slot="prefix" class="el-input__icon el-icon-search"></i>
            </el-input>
            <el-button type="primary" size="small" @click="onSeachClick">
                <i class="el-icon-search"></i> 搜索
            </el-button>
            <el-button type="success" size="small" @click="onAddClick">
                <i class="el-icon-plus"></i> 新增
            </el-button>
        </div>
        <el-table :data="routeList" style="width: 100%; cursor: pointer;" border height="calc(100% - 100px)"
            max-height="calc(100% - 100px)" @row-click="handleRouteRowClick" highlight-current-row>
            <el-table-column prop="routeID" label="线路ID" width="80"></el-table-column>
            <el-table-column prop="routeName" label="线路名称" min-width="120"></el-table-column>
            <!-- 操作列 -->
            <el-table-column label="操作" width="160" fixed="right">
                <template slot-scope="scope">
                    <el-button type="primary" size="mini" @click.stop="openEditDialog(scope.row)">
                        <i class="el-icon-edit"></i> 编辑
                    </el-button>
                    <el-button type="danger" size="mini" @click.stop="deleteRoute(scope.row)">
                        <i class="el-icon-delete"></i> 删除
                    </el-button>
                </template>
            </el-table-column>
        </el-table>
        <div style="margin-top: 10px; text-align: right;">
            <kl-pagination :total="total" @current-change="pageChange" :current-page.sync="PageNo">
            </kl-pagination>
        </div>
    </div>
</template>
<script>
import { queryAutoRouteList } from '@/http/vehicle'
export default {
    name: "RouteList",
    props: {

    },
    mounted() {
        this.loadRouteList();
    },
    computed: {


    },
    data() {
        return {
            routeList: [],
            PageNo: 1,
            searchKeyword: "",
            // 线路分页数据
            total: 0,
            pageSize: 10,
        }
    },
    methods: {
         
        pageChange(page) {
            this.PageNo = page;
            this.loadRouteList();
        },
        onSeachClick() {
            this.loadRouteList();
        },
        // 加载线路列表
        loadRouteList() {
            queryAutoRouteList({
                operatorID: 0,
                routeName: this.searchKeyword,
                pageNo: this.PageNo,
                pageSize: this.pageSize,
            }).then(res => {
                console.log(res);
                if (res.code === 200) {
                    this.routeList = res.data.list || [];
                    this.total = res.data.total || 0;
                }
            })
        },
        onAddClick() {
            this.$emit("addClick");
        },
        handleRouteRowClick(row) {
            this.$emit("rowClick", row);
        },
        // 线路分页事件处理
        handleRouteSizeChange(val) {
            this.routePagination.pageSize = val;
            this.routePagination.currentPage = 1;
        },
        handleRouteCurrentChange(val) {
            this.routePagination.currentPage = val;
        },
        openEditDialog(row) {
            this.$emit("editClick", row);
        },
        deleteRoute(row) {
            this.$emit("deleteClick", row);
        },
    }
}

</script>